import { useCachedBasketData } from '@JohnLewisPartnership/jl-design-system/utils/basket/cachedBasket';
import {
  useBreadcrumbContext,
  useCompareContext,
  useProductContext,
} from '../../../../../context/PlpContext';
import { useExperiencesContext } from '../../../../experiences/Experiences';

export const useCompareHeaderData = () => {
  const cachedBasket = useCachedBasketData();
  const compare = useCompareContext();
  const experiences = useExperiencesContext();
  const productContext = useProductContext();
  const breadcrumbContext = useBreadcrumbContext();

  const getAnalyticsProductData = (productId) => {
    const { products } = productContext;
    return products.find((product) => product.id === productId);
  };

  return {
    experiences,
    compare,
    cachedBasket,
    breadcrumbContext,
    getAnalyticsProductData,
  };
};
